define('ch_section_interest',[
    "jquery",
    "ch_selectors",
    "ch_modal_window"
], function($) {
    $(function() {
        CH.showSectionInterestModal = function(
            sectionId,
            courseName,
            providerName
        ) {
            ga(
                'send',
                'event',
                'Learn More',
                'Click to Learn More',
                providerName + ': ' + courseName,
                { nonInteraction: false }
            );

            // If user already gave us their email, submit the request and show a swal.
            // Otherwise show user section interest modal.
            if (CH.getCookie('ch_i')) {
                $.ajax({
                    type: 'POST',
                    url: '/user/subscription/section-interest-post',
                    data: {
                        hasIdentity: true,
                        schedule: sectionId
                    },
                    success: function (res) {
                        if (res.success) {
                            interestSubmissionSuccess(providerName, courseName);
                        } else if (!res.success && res.error) {
                            swal(
                                'Oh dear! There seems to be a problem.',
                                res.error,
                                'error'
                            );
                        }
                    }
                });
            } else {
                var ModalWindowSectionInterest = new ModalWindowSectionInterestOverlay();
                ModalWindowSectionInterest.show({
                    onSuccess: function (res) {
                        if (res.success) {
                            interestSubmissionSuccess(providerName, courseName);
                        }
                    },
                    onShow: function() {
                        $('#form_SectionInterest').attr('action', function(i, val) {
                            return val + '&schedule=' + sectionId;
                        });
                    },
                    autofocus: false
                });
            }
        };
    });

    function interestSubmissionSuccess(providerName, courseName) {
        ga(
            'send',
            'event',
            'Learn More',
            'Submit Email',
            providerName + ': ' + courseName,
            { nonInteraction: false }
        );

        swal({
            type: 'success',
            title: 'Thank you!',
            text: "You'll hear from us soon!"
        });
    }
});

